import { combineReducers, configureStore } from '@reduxjs/toolkit';
import toastReducer from './slices/toastSlice';
import cuidListReducer from './slices/cuidListSlice';
import {
  forecastPeriodReducer,
  forecastReducer,
  forecastTodayReducer,
  forecastTommorowReducer,
  forecastCurrentMonthReducer,
} from './slices/forecastSlice';
import {
  customerReducer,
  meterDailyReducer,
  meterMonthlyReducer,
  siteNameReducer,
} from './slices/overviewSlice';

const rootReducer = combineReducers({
  toast: toastReducer,
  cuidList: cuidListReducer,
  forecast: forecastReducer,
  period: forecastPeriodReducer,
  today: forecastTodayReducer,
  tommorow: forecastTommorowReducer,
  customer: customerReducer,
  meterDaily: meterDailyReducer,
  meterMonthly: meterMonthlyReducer,
  currentMonth: forecastCurrentMonthReducer,
  sites: siteNameReducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    preloadedState,
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
